var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import classNames from "classnames";
import MaterialPopover from "@mui/material/Popover";
// styles
import "./popover.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-popover",
    isOpen: false,
    position: { vertical: "top", horizontal: "left" },
};
const Popover = (_a) => {
    var _b;
    var { trigger, isOpen, onClose, position, transformOrigin, className, children } = _a, rest = __rest(_a, ["trigger", "isOpen", "onClose", "position", "transformOrigin", "className", "children"]);
    const classList = classNames("tecma-popover", className);
    const ref = useRef(null);
    useEffect(() => {
        if (isOpen) {
            window.addEventListener("scroll", onClose);
            return () => window.removeEventListener("scroll", onClose);
        }
        return () => { };
    }, [isOpen]);
    return (_jsxs(_Fragment, { children: [React.cloneElement(trigger, {
                ref,
                className: trigger
                    ? classNames(trigger.props.className, "popover-trigger")
                    : "popover-trigger",
            }), _jsx(MaterialPopover, Object.assign({ anchorEl: ref.current, anchorOrigin: position, transformOrigin: transformOrigin, open: isOpen, onClose: onClose, classes: { paper: classList }, disableScrollLock: true, slotProps: {
                    paper: {
                        style: { minWidth: (_b = ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width },
                    },
                } }, rest, { children: children }))] }));
};
Popover.defaultProps = defaultProps;
export default React.memo(Popover);
